<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('用户手机号')" prop="userId">
        <a-select
          style="width: 100%"
          v-model="form.userId"
          placeholder="请选择用户"
          allowClear
          :filter-option="false"
          :show-arrow="false"
          :not-found-content="null"
          :default-active-first-option="false"
          show-search
          @search="handleUserSearch"
          @change="handleUserChange"
        >
          <a-select-option v-for="(item, index) in userList" :value="item.id" :key="index">
            {{ item.mobile }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('商品.售卖店铺')" prop="shopId">
        <a-select
          style="width: 100%"
          v-model="form.shopId"
          placeholder="请选择门店"
          allowClear
          :filter-option="false"
          :show-arrow="false"
          :not-found-content="null"
          :default-active-first-option="false"
          show-search
          @search="handleShopSearch"
          @change="handleShopChange"
        >
          <a-select-option v-for="(item, index) in shopList" :value="item.id" :key="index">
            {{ item.shopName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!--      <a-form-model-item prop="incomeGold" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('店铺和用户积分.积分')}}<template slot="title">{{$t('店铺和用户积分.积分')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.incomeGold"  :placeholder="$t('通用.输入.请输入')+$t('店铺和用户积分.积分')" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="remark" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('店铺和用户积分.备注')}}<template slot="title">{{$t('店铺和用户积分.备注')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserScore, listUnBindUser, addUserScore, updateUserScore } from '@/api/shop/userScore'
import { listShop } from '@/api/shop/shop'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      shopList: [],
      userList: [],
      // 表单参数
      form: {
        id: null,

        userId: null,

        shopId: null,

        incomeGold: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [{ required: true, message: this.$t('请选择用户'), trigger: 'blur' }],
        shopId: [{ required: true, message: this.$t('请选择门店'), trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    this.getShopList()
    this.getUnBindUserList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    //店铺选择
    handleShopSearch(value) {
      listShop({ shopName: value }).then((response) => {
        this.shopList = response.data
      })
      // listBrand(({"name": value}))
    },
    handleShopChange(value) {
      this.shopId = value.id
      this.getShopList()
    },
    getShopList() {
      listShop().then((response) => {
        this.shopList = response.data
      })
    },
    getUnBindUserList() {
      listUnBindUser().then((response) => {
        this.userList = response.data
      })
    },
    handleUserChange(value) {
      this.userId = value.id
      this.getUnBindUserList()
    },
    handleUserSearch(value) {
      listUnBindUser({ mobile: value }).then((response) => {
        this.userList = response.data
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        shopId: null,
        incomeGold: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserScore({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateUserScore(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addUserScore(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
